/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/books.scss';
import LineChart from '../../component/Inc/LineChart';
import Calendar from '../../component/Inc/Calendar';
import PopRefundList from './_PopRefundList';
import PopBookCompany from './_PopBookCompany';

const Refund = () => {
  const [modalRefundListOpen, setModalRefundListOpen] = useState(false);
  const [modalBookCompanyOpen, setModalBookCompanyOpen] = useState(false);
  const navigate = useNavigate();
  const lineChartWidth = '100%';
  const lineChartHeight = '200px';

  //Linechartlabels
  const lineChartlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  // line chart data
  const lineChartData = {
    lineChartlabels,
    datasets: [
      {
        label: '발송',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '반품',
        data: [7, 7.5, 4.5, 5.25, 6.5, 6.85, 8, 3, 1, 7, 6, 9.5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      }
    ]
  };
  return (
    <main className="com_container com_books p_refund">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_10 ">총판발송 / 반품내역</h2>
          <button onClick={() => setModalBookCompanyOpen(true)} className="com_btn orange s btn_plus">
            총판 관리
          </button>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <section className="com_board_search end">
              <div className="date_wrap ">
                <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                <span className="divider"> ~ </span>
                <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                <button className="com_btn gray s">조회</button>
              </div>
            </section>

            <div className="calendar">
              <Calendar />
            </div>
            <table className="com_board_list ">
              <colgroup>
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
                <col width="{{ width: 'calc(100% / 12)' }}" />
              </colgroup>
              <thead>
                <tr>
                  <th>NO</th>
                  <th>
                    <button className="arrow active" />
                    총판명
                  </th>
                  <th>
                    <button className="arrow active" />
                    발송 권 수
                  </th>
                  <th>
                    <button className="arrow active" />
                    발송 금액
                  </th>
                  <th>
                    <button className="arrow active" />
                    반품 권 수
                  </th>
                  <th>
                    <button className="arrow active" />
                    반품 금액
                  </th>
                  <th>실 매출액</th>
                  <th>입금액</th>
                  <th>잔액</th>
                  <th>조정 금액</th>
                  <th>현 잔액</th>
                  <th>상세 보기</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_point td_width">
                    +40,000
                    <button onClick={() => setModalRefundListOpen(true)} className="btn_edit" />
                  </td>
                  <td>450,000</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Refund/Detail');
                      }}
                      className="btn_link"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_red td_width">
                    -560,000
                    <button onClick={() => setModalRefundListOpen(true)} className="btn_edit" />
                  </td>
                  <td>450,000</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Refund/Detail');
                      }}
                      className="btn_link"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_point td_width">
                    +40,000
                    <button onClick={() => setModalRefundListOpen(true)} className="btn_edit" />
                  </td>
                  <td>450,000</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Refund/Detail');
                      }}
                      className="btn_link"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_point td_width">+40,000</td>
                  <td>450,000</td>
                  <td
                    onClick={() => {
                      navigate('/Books/Refund/Detail');
                    }}
                    className="btn_link"
                  >
                    보기
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_point td_width">+40,000</td>
                  <td>450,000</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Refund/Detail');
                      }}
                      className="btn_link"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_point td_width">+40,000</td>
                  <td>450,000</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Refund/Detail');
                      }}
                      className="btn_link"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_point td_width">+40,000</td>
                  <td>450,000</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Refund/Detail');
                      }}
                      className="btn_link"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_point td_width">+40,000</td>
                  <td>450,000</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Refund/Detail');
                      }}
                      className="btn_link"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_point td_width">+40,000</td>
                  <td>450,000</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Refund/Detail');
                      }}
                      className="btn_link"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>서울 제일총판</td>
                  <td>45</td>
                  <td className="td_point">78,450,000</td>
                  <td>20</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td className="td_point td_width">+40,000</td>
                  <td>450,000</td>
                  <td>
                    <button
                      onClick={() => {
                        navigate('/Books/Refund/Detail');
                      }}
                      className="btn_link"
                    >
                      보기
                    </button>
                  </td>
                </tr>
                <tr className="summarized_rows">
                  <td></td>
                  <td className="td_point">2023</td>
                  <td className="td_point">6456</td>
                  <td className="td_point">784,500,000</td>
                  <td className="td_point">464</td>
                  <td className="td_red">-350,000</td>
                  <td className="td_point">4,500,000</td>
                  <td className="td_point">4,500,000</td>
                  <td className="td_point">4,500,000</td>
                  <td className="td_point">4,500,000</td>
                  <td className="td_point">4,500,000</td>
                  <td className="td_point"></td>
                </tr>
                <tr className="summarized_rows">
                  <td></td>
                  <td className="">2022</td>
                  <td>123</td>
                  <td>784,500,000</td>
                  <td>31</td>
                  <td>-350,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td>450,000</td>
                  <td></td>
                </tr>

                <tr className="summarized_rows">
                  <td></td>
                  <td>증감율</td>
                  <td>
                    <span className="arrow_blue">123</span>
                  </td>
                  <td>
                    <span className="arrow_blue">450,000</span>
                  </td>
                  <td>
                    <span className="arrow_blue">31</span>
                  </td>
                  <td>
                    <span className="arrow_blue">50,000</span>
                  </td>
                  <td>
                    <span className="arrow_blue">50,000</span>
                  </td>
                  <td>
                    <span className="arrow_blue">50,000</span>
                  </td>
                  <td>
                    <span className="arrow_blue">50,000</span>
                  </td>
                  <td>
                    <span className="arrow_blue">40,000</span>
                  </td>
                  <td>
                    <span className="arrow_blue">50,000</span>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div className="com_calendar_wrap">
              <div className="year">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
            </div>

            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_labels">
                  <div className="chart_name">
                    <div className="chart_item">
                      <span className="chart_name_label">발송</span>
                      <div className="chart_slider chart_orange"></div>
                    </div>
                    <div className="chart_item">
                      <span className="chart_name_label">반품</span>
                      <div className="chart_slider chart_blue"></div>
                    </div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart data={lineChartData} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <PopBookCompany open={modalBookCompanyOpen} close={() => setModalBookCompanyOpen(false)} />
      <PopRefundList open={modalRefundListOpen} close={() => setModalRefundListOpen(false)} />
    </main>
  );
};

export default Refund;
